import { render } from "./send-command.vue?vue&type=template&id=4bb40fe6&scoped=true"
import script from "./send-command.vue?vue&type=script&lang=js"
export * from "./send-command.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4bb40fe6"

export default script